import { Caddy } from '@bechtel/types';

export interface CaddySelectorProps {
  fieldName: string;
  selectedCaddies?: Caddy[];
}
